/* WIOGA 2.0 — quick add + hero video. Ingen afhængigheder. */
(function () {
  if (window.__w2Init) return;
  window.__w2Init = true;

  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'w2-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-link__count');
        nodes.forEach(function (n) { n.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  function addItems(items, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Tilføjer…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) {
          showToast('<span>' + (res.d.description || 'Kunne ikke lægges i kurven') + '</span>');
          return;
        }
        refreshCartCount();
        if (window.w2cart && document.querySelector('[data-w2-drawer]')) {
          window.w2cart.changed();
          window.w2cart.open();
        } else {
          showToast('<span>Lagt i kurven</span><a href="/cart">Se kurv</a>');
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        showToast('<span>Noget gik galt. Prøv igen.</span>');
      });
  }

  /* PDP-formularen (Symmetry) gaar samme vej som quick-add: fanges i capture-fasen, foer theme.js'
     egen submit-handler (der ellers viser temaets "lagt i kurven"-overlay). Uden JS poster den normalt. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-purchase-form');
    if (!form || !document.querySelector('[data-w2-drawer]')) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    e.preventDefault();
    e.stopPropagation();
    var qty = form.querySelector('[name="quantity"]');
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (i) { if (i.value) props[i.name.slice(11, -1)] = i.value; });
    var item = { id: Number(id.value), quantity: Number(qty && qty.value ? qty.value : 1) };
    if (Object.keys(props).length) item.properties = props;
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) item.selling_plan = Number(sp.value);
    addItems([item], form.querySelector('button[type="submit"]'));
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-w2-add]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    if (!id) return;
    addItems([{ id: Number(id.value), quantity: Number(qty && qty.value ? qty.value : 1) }], form.querySelector('button'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-w2-add-all]');
    if (!btn) return;
    e.preventDefault();
    var ids = (btn.getAttribute('data-w2-add-all') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    addItems(ids.map(function (i) { return { id: Number(i), quantity: 1 }; }), btn);
  });

  function bootVideo(v) {
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    var ready = function () { v.classList.add('is-ready'); };
    if (v.readyState >= 3) ready(); else v.addEventListener('loadeddata', ready, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideos() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('video[data-w2-video]').forEach(function (v) {
      if (reduce) { v.remove(); return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { bootVideo(v); obs.disconnect(); }
          });
        }, { rootMargin: '200px' }).observe(v);
      } else {
        bootVideo(v);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideos);
  } else {
    initVideos();
  }
  document.addEventListener('shopify:section:load', initVideos);
})();

/* ==========================================================================
   WIOGA 2.0 — bevægelse. Porteret fra mockuppens a2.js.
   Alt er transform og opacity, samles i én requestAnimationFrame, og
   slukkes helt ved prefers-reduced-motion.
   ========================================================================== */
(function () {
  if (window.__w2Motion) return;
  window.__w2Motion = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- shop the look: hotspots følger billedet ---------- */
  /* x/y på hvert hotspot er procent af BILLEDET. Med object-fit:cover
     beskæres billedet forskelligt ved hver bredde, så positionerne regnes
     om ud fra den faktiske gengivelse. OBJ_X/OBJ_Y holdes i sync med
     object-position i w2.css. */
  function initLook(root) {
    (root || document).querySelectorAll('[data-w2-look]').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      var spots = [].slice.call(wrap.querySelectorAll('[data-hs]'));
      if (!img || !spots.length) return;
      var OBJ_X = 0.5, OBJ_Y = 0.48;

      function place() {
        if (!img.naturalWidth) return;
        var cw = wrap.clientWidth, ch = wrap.clientHeight;
        var k = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
        var dw = img.naturalWidth * k, dh = img.naturalHeight * k;
        var x0 = (cw - dw) * OBJ_X, y0 = (ch - dh) * OBJ_Y;
        spots.forEach(function (el) {
          var x = x0 + dw * parseFloat(el.getAttribute('data-x')) / 100;
          var y = y0 + dh * parseFloat(el.getAttribute('data-y')) / 100;
          el.style.left = x + 'px';
          el.style.top = y + 'px';
          /* falder et smykke uden for beskæringen, skjules prikken
             i stedet for at pege på ingenting */
          el.style.visibility = (x > 8 && x < cw - 8 && y > 8 && y < ch - 8) ? '' : 'hidden';
        });
      }

      if (img.complete) place();
      img.addEventListener('load', place);
      window.addEventListener('resize', place);

      /* hotspot og varelinje lyser op sammen */
      function link(i, on) {
        var h = wrap.querySelector('[data-hs="' + i + '"]');
        var r = document.querySelector('[data-row="' + i + '"]');
        if (h) h.classList.toggle('on', on);
        if (r) r.classList.toggle('hot', on);
      }
      spots.forEach(function (b) {
        var i = b.getAttribute('data-hs');
        b.addEventListener('mouseenter', function () { link(i, true); });
        b.addEventListener('mouseleave', function () { link(i, false); });
        b.addEventListener('focus', function () { link(i, true); });
        b.addEventListener('blur', function () { link(i, false); });
      });
      document.querySelectorAll('[data-row]').forEach(function (r) {
        var i = r.getAttribute('data-row');
        r.addEventListener('mouseenter', function () { link(i, true); });
        r.addEventListener('mouseleave', function () { link(i, false); });
      });
    });
  }

  /* ---------- header reagerer på scroll ---------- */
  function initHeader() {
    var hdr = document.querySelector('[data-w2-header]');
    if (!hdr) return;
    var last = null;
    function upd() {
      var s = window.scrollY > 12;
      if (s !== last) { hdr.classList.toggle('stuck', s); last = s; }
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- reveal, parallax, vandret drift ---------- */
  function initMotion(root) {
    var scope = root || document;

    /* produktkort afsløres ét ad gangen, så en række ikke popper samlet ind */
    scope.querySelectorAll('.w2-grid, .w2-rail, .w2-cats, .w2-proof__row').forEach(function (g) {
      [].slice.call(g.children).forEach(function (c, i) {
        c.classList.add('rv');
        if (i < 6) c.classList.add('rv-' + (i + 1));
      });
    });

    var alle = [].slice.call(scope.querySelectorAll('.rv'));
    function vis(el) { el.classList.add('in'); }

    if (!('IntersectionObserver' in window)) { alle.forEach(vis); return; }

    var fired = false;
    var io = new IntersectionObserver(function (es, o) {
      fired = true;
      es.forEach(function (e) { if (e.isIntersecting) { vis(e.target); o.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    alle.forEach(function (el) { io.observe(el); });

    /* Nødbremse: sker der noget uventet, så observeren ALDRIG fyrer, skal
       indholdet frem alligevel. Den maa kun gribe ind i det tilfaelde —
       ellers ville den afsloere hele siden faa sekunder efter load, og saa
       var der intet tilbage at se, naar man scroller. */
    setTimeout(function () { if (!fired) { alle.forEach(vis); } }, 2500);

    if (REDUCED) return;

    var px = [].slice.call(document.querySelectorAll('.px'));
    var drift = document.querySelector('[data-w2-drift]');
    if (!px.length && !drift) return; /* globalt indlaest: ingen scroll-lytter paa sider uden parallax/drift */
    var tick = false;

    function frame() {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var img = el.querySelector('.px__i');
        if (!img) return;
        var amt = parseFloat(el.getAttribute('data-px') || 7);
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = 'translate3d(0,' + (-prog * amt).toFixed(2) + '%,0) scale(' + (1 + amt / 100) + ')';
      });
      if (drift) {
        var dr = drift.getBoundingClientRect();
        if (dr.bottom > 0 && dr.top < vh) {
          var dp = (dr.top + dr.height / 2 - vh / 2) / vh;
          drift.style.transform = 'translate3d(' + (-dp * 26).toFixed(1) + 'px,0,0)';
        }
      }
      tick = false;
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function boot() { initHeader(); initLook(); initMotion(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* temaeditoren genindlæser sektioner uden at genindlæse siden */
  document.addEventListener('shopify:section:load', function (e) {
    initLook(e.target); initMotion(e.target); initHeader();
  });
})();

/* ==========================================================================
   WIOGA 2.0 — A5-adfærd. Porteret fra mockups/a5.js.
   ========================================================================== */
(function () {
  if (window.__w2A5) return;
  window.__w2A5 = true;

  /* ---------- shoppable video: hent og afspil kun naer skaermen ---------- */
  function initShopVideo(root) {
    var wraps = (root || document).querySelectorAll('[data-w2-shopvideo]');
    if (!wraps.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wraps.forEach(function (wrap) {
      var vids = [].slice.call(wrap.querySelectorAll('video'));
      if (reduced) { vids.forEach(function (v) { v.remove(); }); return; }   /* posteren staar alene */
      if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { if (!v.src) v.src = v.dataset.src; v.play().catch(function(){}); }); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.src && v.dataset.src) v.src = v.dataset.src;
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.15 });
      vids.forEach(function (v) { io.observe(v); });
    });
  }

  /* ---------- video-spor: pile paa computer (V2) ---------- */
  /* pilene giver kun mening, naar raekken faktisk kan scrolles */
  function svNavVisibility(sec) {
    var rail = sec.querySelector('.w2-sv'), nav = sec.querySelector('[data-w2-svnav]');
    if (!rail || !nav) return;
    nav.style.display = rail.scrollWidth > rail.clientWidth + 4 ? '' : 'none';
  }

  function initSvNav(root) {
    (root || document).querySelectorAll('[data-w2-svsec]').forEach(function (sec) {
      var nav = sec.querySelector('[data-w2-svnav]'), track = sec.querySelector('[data-w2-shopvideo]');
      if (!nav || !track || nav.__w2) return;
      nav.__w2 = true;
      svNavVisibility(sec);
      window.addEventListener('resize', function () { svNavVisibility(sec); }, { passive: true });
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-dir]'); if (!b) return;
        var card = track.firstElementChild; var step = card ? card.getBoundingClientRect().width + 24 : 300;
        track.scrollBy({ left: step * 2 * Number(b.dataset.dir), behavior: 'smooth' });
      });
    });
  }

  /* ---------- metal: guld/soelv-toggle paa telefon ---------- */
  function initMetal(root) {
    (root || document).querySelectorAll('[data-w2-metal]').forEach(function (sec) {
      var tog = sec.querySelector('.w2-metal__tog'); if (!tog) return;
      tog.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-metal]'); if (!b) return;
        tog.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        sec.querySelectorAll('.w2-metal__s').forEach(function (p) {
          p.classList.toggle('on', p.classList.contains('w2-metal__s--' + b.dataset.metal));
        });
      });
    });
  }

  /* ---------- Symmetrys footer: menugrupper som accordions paa telefon ----------
     Vi bygger ikke en ny footer. Symmetrys egne kolonner (menu-blokke og
     tekst-blokke med overskrift) faar en klikbar overskrift under 760px;
     over 760px roeres intet. */
  function initFooter() {
    var blocks = [].slice.call(document.querySelectorAll('.section-footer__menu-block, .section-footer__text-block--with-text'));
    if (!blocks.length) return;
    var mq = window.matchMedia('(max-width: 759px)');
    blocks.forEach(function (b) {
      if (b.classList.contains('w2-ftacc')) return;
      var h = b.querySelector('.section-footer__title'), ul = b.querySelector('.section-footer__menu-block__menu, .section-footer__text');
      if (!h || !ul) return;
      b.classList.add('w2-ftacc');
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
      var set = function (open) { b.classList.toggle('w2-ftacc--open', open); h.setAttribute('aria-expanded', open); };
      var sync = function () { set(!mq.matches); };
      h.addEventListener('click', function () { if (mq.matches) set(!b.classList.contains('w2-ftacc--open')); });
      h.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && mq.matches) { e.preventDefault(); set(!b.classList.contains('w2-ftacc--open')); } });
      sync(); mq.addEventListener('change', sync);
    });
  }

  function boot() { initShopVideo(); initSvNav(); initMetal(); initFooter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener("shopify:section:load", function (e) { initShopVideo(e.target); initSvNav(e.target); initMetal(e.target); initFooter(); });
})();

/* ---------- Kollektion V1: "Vis flere" oven paa Symmetrys paginate + sortering via filterformularen ----------
   Symmetry ajax-udskifter [data-ajax-container]; vores knap ligger i den, saa den foelger med filtre.
   Klik: hent naeste side, tag kortene ud af dens [data-w2-grid], haeng dem paa, opdatér knap/taeller.
   Uden JS eller ved fejl: nummereret paginering nedenfor virker som foer. */
(function () {
  function coll() { return document.querySelector('[data-w2-coll]'); }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-w2-more]');
    if (!more) return;
    var root = coll(); if (!root) return;
    e.preventDefault();
    if (more.getAttribute('aria-busy') === 'true') return;
    more.setAttribute('aria-busy', 'true'); more.classList.add('is-busy');
    var url = more.getAttribute('href');
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-w2-grid]');
        var grid = root.querySelector('[data-w2-grid]');
        if (!newGrid || !grid) { window.location.href = url; return; }
        var frag = document.createDocumentFragment();
        [].slice.call(newGrid.children).forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
        var newMore = doc.querySelector('[data-w2-more]');
        var wrap = root.querySelector('[data-w2-more-wrap]');
        if (newMore && wrap) { wrap.innerHTML = ''; wrap.appendChild(newMore); } else if (wrap) { wrap.innerHTML = ''; }
        var shown = root.querySelector('[data-w2-shown]');
        if (shown) shown.textContent = grid.children.length;
        try { history.replaceState(history.state, '', url); } catch (x) {}
        root.classList.add('w2-coll--more-active');
      })
      .catch(function () { window.location.href = url; });
  });

  /* sortering fra dropdown: saet radioen i #CollectionFilterForm og lad Symmetrys ajax-filtrering koere,
     saa aktive filtre bevares. Linkets href er no-JS-fallback. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-w2-sort]');
    if (!a) return;
    var form = document.getElementById('CollectionFilterForm');
    var radio = form && form.querySelector('input[name="sort_by"][value="' + a.getAttribute('data-w2-sort') + '"]');
    if (!form || !radio || typeof jQuery === 'undefined') return; /* fallback: normalt link */
    e.preventDefault();
    e.stopPropagation(); /* Symmetrys eget link-handler maa ikke ogsaa hente href'en (uden filtre) */
    radio.checked = true;
    var dd = a.closest('.link-dropdown');
    var btn = dd && dd.querySelector('.link-dropdown__button');
    if (btn) { var t = btn.querySelector('.link-dropdown__button-text'); if (t) t.textContent = a.textContent; if (btn.getAttribute('aria-expanded') === 'true') jQuery(btn).trigger('click'); }
    jQuery(form).trigger('change');
  }, true);

  function markMore() { var r = coll(); if (r && r.querySelector('[data-w2-more]')) r.classList.add('w2-coll--more-active'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markMore); else markMore();
})();

/* ---------- Produktside V1 ----------
   1) prikker til Symmetrys slick-slideshow paa telefon (Symmetry saetter dots:false)
   2) sticky koebsbar naar formularens CTA er ude af billedet; skjules ved Opus-kurv/cookie-banner
   3) "Style med": henter anbefalinger via Section Rendering API og indsaetter sektionens HTML */
(function () {
  function initDots() {
    /* V2: uafhaengig af hvilken jQuery-instans der er global (apps overskriver window.jQuery).
       Slick laegger sin instans paa selve elementet (ss.slick). Vi venter paa den og laeser currentSlide. */
    var ss = document.querySelector('[data-w2-pdp] .product-slideshow');
    if (!ss) return;
    var host = ss.closest('.gallery__inner') || ss.parentElement;
    function inst() { return ss.slick && typeof ss.slick.slideCount === 'number' ? ss.slick : null; }
    function build() {
      var sl = inst();
      var old = host.querySelector('.w2-dots');
      if (!sl || !ss.classList.contains('slick-slider') || sl.slideCount < 2) { if (old) old.remove(); return; }
      var dots = old;
      if (!dots) { dots = document.createElement('div'); dots.className = 'w2-dots'; var mi = host.querySelector('.main-image'); if (mi && mi.parentElement === host) mi.insertAdjacentElement('afterend', dots); else host.appendChild(dots); }
      if (dots.children.length !== sl.slideCount) {
        dots.innerHTML = '';
        for (var i = 0; i < sl.slideCount; i++) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Billede ' + (i + 1));
          b.addEventListener('click', (function (idx) { return function () { var s2 = inst(); if (s2) s2.slickGoTo(idx); }; })(i));
          dots.appendChild(b);
        }
      }
      [].forEach.call(dots.children, function (b, i) { b.classList.toggle('is-on', i === sl.currentSlide); });
    }
    var tries = 0;
    var t = setInterval(function () { tries++; if (inst() || tries > 40) { clearInterval(t); build(); } }, 150);
    ['transitionend', 'touchend', 'pointerup', 'click'].forEach(function (ev) { ss.addEventListener(ev, function () { setTimeout(build, 60); setTimeout(build, 450); }, true); });
    window.addEventListener('resize', function () { setTimeout(build, 400); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-w2-sticky]'); if (!bar) return;
    var anchor = document.querySelector('[data-w2-cta-anchor], .product-unavailable, [data-w2-pdp] .buy-buttons-row');
    if (!anchor) return;
    var passed = false, blocked = false;
    function apply() { var on = passed && !blocked; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { passed = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }); }, { threshold: 0 }).observe(anchor);
    }
    function checkOverlays() {
      var banner = document.getElementById('shopify-pc__banner');
      var bannerOpen = !!(banner && banner.offsetParent !== null && getComputedStyle(banner).visibility !== 'hidden');
      blocked = bannerOpen || document.body.classList.contains('opus-modal-open') || document.body.classList.contains('cc-popup-no-scroll');
      apply();
    }
    new MutationObserver(checkOverlays).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    document.addEventListener('click', function () { setTimeout(checkOverlays, 300); }, true);
    checkOverlays();
  }

  function initStyleMed() {
    var el = document.querySelector('[data-w2-stylemed][data-url]'); if (!el) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-w2-stylemed]');
      if (fresh && fresh.querySelector('.w2-c')) { el.innerHTML = fresh.innerHTML; el.classList.remove('w2-stylemed--pending'); }
    }).catch(function () {});
  }

  function boot() { initDots(); initSticky(); initStyleMed(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 50); }); else setTimeout(boot, 50);
})();


/* ---------- Kurv V1: native W2-skuffe + /cart ----------
   Ét kurvsystem: Shopifys AJAX-API (/cart/add.js, /cart/change.js, /cart/update.js) + Section Rendering API
   (/?sections=w2-cart-drawer) til at gentegne skuffen. Symmetrys eget 'theme:cartchanged'-event udsendes,
   saa headerens taeller opdateres af temaets kode (ingen konkurrerende tilstand). */
(function () {
  var drawer = document.querySelector('[data-w2-drawer]');
  var busy = false;
  var lastFocus = null;

  function emitChanged() {
    try { document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })); } catch (e) {}
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch('/?sections=w2-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['w2-cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-w2-drawer-content]');
        var cur = drawer.querySelector('[data-w2-drawer-content]');
        if (fresh && cur) cur.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function refreshCartPage() {
    var root = document.querySelector('[data-w2-cart]');
    if (!root) return Promise.resolve();
    var id = root.getAttribute('data-section-id');
    return fetch(location.pathname + '?section_id=' + id, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-w2-cart]');
        if (fresh) root.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function changed() { return Promise.all([refreshDrawer(), refreshCartPage()]).then(emitChanged); }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('w2-drawer-open');
    var p = drawer.querySelector('.w2-drawer__panel'); if (p) p.focus({ preventScroll: true });
  }
  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('w2-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('[data-w2-cart-items]').forEach(function (el) { el.classList.toggle('is-busy', on); });
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); })
      .then(function () { return changed(); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  var noteTimer;
  function saveNote(v) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: v }) }).catch(function () {});
    }, 500);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-w2-drawer-close]')) { e.preventDefault(); close(); return; }
    var cartLink = t.closest('.cart-link, a[href="/cart"].header__cart, [data-w2-open-cart]');
    if (cartLink && drawer && !t.closest('[data-w2-cart]')) { e.preventDefault(); changed().then(open); return; }
    var up = t.closest('[data-w2-qty-up]'), down = t.closest('[data-w2-qty-down]'), rm = t.closest('[data-w2-remove]');
    var row = t.closest('[data-w2-line]');
    if ((up || down || rm) && row) {
      e.preventDefault();
      var line = Number(row.getAttribute('data-w2-line'));
      var input = row.querySelector('[data-w2-qty-input]');
      var q = input ? Number(input.value) || 0 : 1;
      if (rm) q = 0; else if (up) q = q + 1; else q = Math.max(0, q - 1);
      if (input) input.value = q;
      change(line, q);
      return;
    }
    var co = t.closest('[data-w2-checkout]');
    if (co) {
      var terms = document.querySelector('[data-w2-terms]');
      if (terms && t.closest('[data-w2-cart]')) {
        var box = terms.querySelector('[data-w2-terms-box]'), err = terms.querySelector('[data-w2-terms-err]');
        if (box && !box.checked) { e.preventDefault(); err.hidden = false; terms.classList.add('is-err'); box.focus(); return; }
      }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-w2-qty-input]');
    if (input) { var row = input.closest('[data-w2-line]'); if (row) change(Number(row.getAttribute('data-w2-line')), Math.max(0, Number(input.value) || 0)); return; }
    var box = e.target.closest('[data-w2-terms-box]');
    if (box && box.checked) { var terms = box.closest('[data-w2-terms]'); terms.classList.remove('is-err'); var err = terms.querySelector('[data-w2-terms-err]'); if (err) err.hidden = true; }
  });
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-w2-note]');
    if (note) saveNote(note.value);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* /cart: uden JS poster #cartform; med JS skal Enter i antal-feltet ikke sende hele formularen */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-w2-qty-input]')) { e.preventDefault(); e.target.blur(); }
  });

  window.w2cart = { open: open, close: close, changed: changed, refresh: refreshDrawer };
})();

/* ==========================================================================
   WIOGA 2.0 — announcement bar. Rolig rotation mellem korte USP'er.
   Ingen pile, ingen swipe: linjen krydsfader af sig selv og staar stille,
   naar musen er over den, naar en besked har fokus, eller naar fanen er skjult.
   prefers-reduced-motion: foerste besked vises, rotationen starter ikke.
   ========================================================================== */
(function () {
  function initAnn(root) {
    var scope = root && root.querySelector ? root : document;
    var el = scope.querySelector('[data-w2-ann]');
    if (!el || el.dataset.w2AnnOn) return;
    var items = Array.prototype.slice.call(el.querySelectorAll('.w2-ann__i'));
    if (items.length < 2) return;
    el.dataset.w2AnnOn = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ms = parseInt(el.getAttribute('data-interval'), 10);
    if (!ms || ms < 2000) ms = 5000;
    var i = 0, timer = null;

    function step() {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }
    function start() { if (!timer && !document.hidden) timer = setInterval(step, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAnn(); });
  } else {
    initAnn();
  }
  document.addEventListener('shopify:section:load', function (e) { initAnn(e.target); });
})();

/* ==========================================================================
   WIOGA 2.0 — scroll-effekter (2026-09-23).
   Et lag oven på det eksisterende reveal-system: samme .rv/.in-klasser og
   samme kurve, bare på flere elementer. Derudover langsom parallakse på de to
   kampagnebilleder og en blød afsked med hero-teksten.
   Alt er additivt: uden JavaScript sættes .js aldrig, og så står alt stille og
   synligt. prefers-reduced-motion slår hele laget fra.
   ========================================================================== */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* elementer der skal glide ind, ud over dem initMotion allerede tager */
  var SOLO = ['.w2-hd', '.w2-camp__t', '.w2-camp2__in', '.w2-nl__t',
              '.w2-hero__k', '.w2-hero__h', '.w2-hero__in .w2-btn'];
  /* rækker hvor børnene skal komme ét ad gangen */
  var ROWS = ['.w2-cols__g', '.w2-sv'];

  function collect(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = [];
    ROWS.forEach(function (sel) {
      [].forEach.call(scope.querySelectorAll(sel), function (row) {
        [].forEach.call(row.children, function (c, i) {
          if (c.classList.contains('rv')) return;
          c.classList.add('rv');
          if (i < 6) c.classList.add('rv-' + (i + 1));
          els.push(c);
        });
      });
    });
    SOLO.forEach(function (sel) {
      [].forEach.call(scope.querySelectorAll(sel), function (e) {
        if (e.classList.contains('rv')) return;
        e.classList.add('rv');
        els.push(e);
      });
    });
    return els;
  }

  function reveal(root) {
    var els = collect(root);
    if (!els.length) return;
    function vis(e) { e.classList.add('in'); }
    if (!('IntersectionObserver' in window)) { els.forEach(vis); return; }
    var fired = false;
    var io = new IntersectionObserver(function (entries, obs) {
      fired = true;
      entries.forEach(function (en) { if (en.isIntersecting) { vis(en.target); obs.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
    /* nødbremse: kun hvis observeren aldrig fyrer (se initMotion) */
    setTimeout(function () { if (!fired) { els.forEach(vis); } }, 2500);
  }

  /* ---- parallakse på kampagnebillederne + hero-teksten der takker af ---- */
  function scrollFx() {
    if (REDUCED) return;
    var pars = [].slice.call(document.querySelectorAll('.w2-camp__m img, .w2-camp2__m img'));
    pars.forEach(function (im) { im.classList.add('w2-pi'); });
    var hero = document.querySelector('.w2-hero');
    var hin = hero && hero.querySelector('.w2-hero__in');
    if (!pars.length && !hin) return;

    var tick = false;
    function frame() {
      var vh = window.innerHeight;
      pars.forEach(function (im) {
        var box = im.parentNode;
        var r = box.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var prog = (r.top + r.height / 2 - vh / 2) / vh;   /* -1 … 1 */
        im.style.transform = 'translate3d(0,' + (-prog * 6).toFixed(2) + '%,0) scale(1.07)';
      });
      if (hin) {
        var hr = hero.getBoundingClientRect();
        if (hr.bottom > 0 && hr.top < vh) {
          var p = Math.min(1, Math.max(0, -hr.top / (hr.height * 0.8)));
          hin.style.opacity = (1 - p).toFixed(3);
          hin.style.setProperty('--w2-lift', (p * -34).toFixed(1) + 'px');
        }
      }
      tick = false;
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function boot() { reveal(); scrollFx(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

/* ==========================================================================
   WIOGA 2.0 — scroll-effekter, lag 2 (2026-09-23).
   1) overskrifter stiger op bag en maske i stedet for bare at tone frem
   2) parallakse ogsaa paa kollektionsbanneret
   3) produktbilledet zoomer ganske lidt ud, naar kortet kommer ind
   4) kollektionsbanner og footer glider ind
   Additivt som resten: uden .js staar alt stille og synligt, og
   prefers-reduced-motion slaar laget fra.
   ========================================================================== */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* overskrifter der faar maske-reveal */
  var MASK = ['.w2-hd h2', '.w2-camp__h', '.w2-nl__h', '.w2-cban__h'];
  /* blokke der bare skal glide ind */
  var RISE = ['.w2-cban__t', '.section-footer__row--blocks'];

  function wrap(el) {
    if (el.dataset.w2Mask) return false;
    el.dataset.w2Mask = '1';
    var inner = document.createElement('span');
    inner.className = 'w2-ln__i';
    while (el.firstChild) { inner.appendChild(el.firstChild); }
    el.appendChild(inner);
    el.classList.add('w2-ln');
    return true;
  }

  function collect(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = [];
    if (!REDUCED) {
      MASK.forEach(function (sel) {
        [].forEach.call(scope.querySelectorAll(sel), function (e) { if (wrap(e)) els.push(e); });
      });
    }
    RISE.forEach(function (sel) {
      [].forEach.call(scope.querySelectorAll(sel), function (e) {
        if (e.classList.contains('rv')) return;
        e.classList.add('rv'); els.push(e);
      });
    });
    return els;
  }

  function reveal(root) {
    var els = collect(root);
    if (!els.length) return;
    function vis(e) { e.classList.add('in'); }
    if (!('IntersectionObserver' in window)) { els.forEach(vis); return; }
    var fired = false;
    var io = new IntersectionObserver(function (en, obs) {
      fired = true;
      en.forEach(function (x) { if (x.isIntersecting) { vis(x.target); obs.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
    /* nødbremse: kun hvis observeren aldrig fyrer (se initMotion) */
    setTimeout(function () { if (!fired) { els.forEach(vis); } }, 2500);
  }

  /* parallakse paa kollektionsbanneret — samme maade som kampagnebillederne */
  function banner() {
    if (REDUCED) return;
    var im = document.querySelector('.w2-cban__m img');
    if (!im) return;
    im.classList.add('w2-pi');
    var box = im.parentNode, tick = false;
    function frame() {
      var vh = window.innerHeight, r = box.getBoundingClientRect();
      if (r.bottom > -100 && r.top < vh + 100) {
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        im.style.transform = 'translate3d(0,' + (-prog * 5).toFixed(2) + '%,0) scale(1.06)';
      }
      tick = false;
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function boot() { reveal(); banner(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

/* ==========================================================================
   WIOGA 2.0 — header oven paa hero'en (kun forsiden).
   Maaler headerens hoejde, loefter hero'en op bag den og skifter tilbage til
   fast flade, naar hero'en er scrollet forbi.
   ========================================================================== */
(function () {
  // Oenskesky-knappen er bar tekst fra appen, og <button> tegner ikke
  // ::before her — derfor indsaettes GoWish' eget sky-ikon som et rigtigt
  // element. Idempotent, og en observer fanger at appen gentegner knappen.
  function initGwIkon() {
    var SVG = '<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.5947 6.36117C21.0026 6.36637 20.3901 6.42506 19.8446 6.6479C20.0092 6.23935 20.0864 5.80408 20.0813 5.36956C20.0763 3.53936 18.6197 2.04265 16.8493 2.04265C15.794 2.04265 14.8006 2.57819 14.1889 3.47548C14.0651 2.0419 11.924 0 9.49446 0C4.73449 0 3.87513 5.18311 4.73449 6.64715C3.12866 6.2126 0 7.35279 0 10.881C0 13.3797 2.3778 15.0086 4.4206 15.4387C6.57191 15.8895 16.8493 16.4363 21.5947 15.4387C23.3855 15.0621 26 13.8892 26 10.9025C26 8.40903 23.7562 6.35004 21.5947 6.36117Z" fill="#E9F5FD"/></svg>';
    function saet() {
      var knapper = document.querySelectorAll('.gowish-btn, #gowishBlueButton');
      for (var i = 0; i < knapper.length; i++) {
        var k = knapper[i];
        if (k.querySelector('.w2-gw-ikon')) continue;
        var ikon = document.createElement('span');
        ikon.className = 'w2-gw-ikon';
        ikon.setAttribute('aria-hidden', 'true');
        ikon.innerHTML = SVG;
        k.insertBefore(ikon, k.firstChild);
      }
    }
    saet();
    new MutationObserver(saet).observe(document.body, { childList: true, subtree: true });
    setTimeout(saet, 1200);
    setTimeout(saet, 3000);
  }

  function initHdrOver() {
    var hero = document.querySelector('.w2-hero');
    var sec = document.querySelector('.section-header');
    if (!hero || !sec || !document.body.classList.contains('template-index')) return;
    var root = document.documentElement;

    function measure() {
      root.style.setProperty('--w2-hdr-h', Math.round(sec.getBoundingClientRect().height) + 'px');
    }
    measure();
    document.body.classList.add('w2-hdr-over');
    measure();

    var solid = false;
    function frame() {
      // Foer blev headeren foerst massiv naar HELE hero'en var forbi, saa
      // den stod gennemsigtig i det meste af det foerste skaermbillede.
      // Nu skifter den saa snart der scrolles, og er kun gennemsigtig i top.
      var past = (window.pageYOffset || document.documentElement.scrollTop || 0) > 24;
      if (past !== solid) {
        solid = past;
        document.body.classList.toggle('w2-hdr-solid', solid);
      }
    }
    var tick = false;
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(function () { frame(); tick = false; }); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); frame(); }, { passive: true });
    frame();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHdrOver);
    document.addEventListener('DOMContentLoaded', initGwIkon);
  } else { initHdrOver(); initGwIkon(); }
})();
